import styled from 'styled-components'

interface Props {
  name: string
  register: any
  value: string
  label?: string
  onClick?: (e: any) => void
}

export default function RadioButton({ name, register, value, label, onClick }: Props): JSX.Element {
  const elementId = Math.random().toString(36).substring(7)
  return (
    <RadioButtonContainer>
      <input
        type="radio"
        name={name}
        {...(register ? register(name) : {})}
        value={value}
        id={elementId}
        onClick={onClick}
      />
      <label htmlFor={elementId}>{label}</label>
    </RadioButtonContainer>
  )
}

const RadioButtonContainer = styled.div`
  display: flex;
  height: 30px;
  margin-bottom: 5px;
  & label {
    margin-left: 10px;
    line-height: 24px;
    cursor: pointer;
  }
  & input[type='radio'] {
    appearance: none;
    border: 2px solid;
    border-color: ${(props) => props.theme.palette.primary.main};
    border-radius: 3px;
    width: 24px;
    height: 24px;
    content: none;
    outline: none;
    margin: 0;
    cursor: pointer;
    position: relative;

    &:checked {
      appearance: none;
      outline: none;
      padding: 0;
      content: none;

      &::before {
        position: absolute;
        left: -10%;
        top: 40%;
        height: 40%;
        width: 3px;
        background-color: ${(props) => props.theme.palette.primary.main};
        content: '';
        transform: translateX(10px) rotate(-45deg);
        transform-origin: left bottom;
      }

      &::after {
        position: absolute;
        left: -10%;
        bottom: 20%;
        height: 3px;
        width: 70%;
        background-color: ${(props) => props.theme.palette.primary.main};
        content: '';
        transform: translateX(10px) rotate(-45deg);
        transform-origin: left bottom;
      }
    }
  }
`
